import sideMenuConfigGenerated from './side-menu-config-generated.json';

export const SideMenuConfig = [...sideMenuConfigGenerated];
